import angular from 'angular';
import React from 'react';
import makeAsyncScriptLoader from 'react-async-script';
import ReactDOM from 'react-dom';
import { makeReCaptchaElement, } from './ReCAPTCHA';
const callbackName = 'onloadcallback';
const globalName = 'grecaptcha';
function createWrapper(size, type) {
    return makeAsyncScriptLoader(`https://google.com/recaptcha/api.js?onload=${callbackName}&render=explicit`, {
        callbackName,
        globalName,
        scriptId: globalName,
        removeOnUnmount: false,
    })(makeReCaptchaElement(size, type));
}
export const ReCAPTCHA = createWrapper('normal');
export const AudioReCAPTCHA = createWrapper('normal', 'audio');
export const InvisibleReCAPTCHA = createWrapper('invisible');
export const CompactReCAPTCHA = createWrapper('compact');
export const CompactAudioReCAPTCHA = createWrapper('compact', 'audio');
function makeAngularWrapper(name, El) {
    return angular
        .module('doxy.common.components.reactGlobalPrice', [])
        .component(`react${name}ReCAPTCHA`, {
        template: `<div></div>`,
        bindings: {
            ref: '=?',
            grecaptcha: '@?',
            onChange: '=?',
            onErrored: '=?',
            onExpired: '=?',
            onMounted: '=?', // ?: () => void;
        },
        controller: function ($element) {
            const render = () => {
                const props = {
                    ref: this.ref,
                    grecaptcha: this.grecaptcha,
                    onChange: this.onChange,
                    onErrored: this.onErrored,
                    onExpired: this.onExpired,
                    onMounted: this.onMounted,
                };
                ReactDOM.render(React.createElement(El, props), $element[0]);
            };
            this.$onChanges = render;
        },
    }).name;
}
/**
 * @description Angularjs wrapper for the `ReCAPTCHA` react component
 * @usage `<react-recaptcha />`
 */
// eslint-disable-next-line camelcase
export const ReCAPTCHA_angularWrapper = makeAngularWrapper('', ReCAPTCHA);
/**
 * @description Angularjs wrapper for the `AudioReCAPTCHA` react component
 * @usage `<react-audio-recaptcha />`
 */
// eslint-disable-next-line camelcase
export const AudioReCAPTCHA_angularWrapper = makeAngularWrapper('Audio', AudioReCAPTCHA);
/**
 * @description Angularjs wrapper for the `InvisibleReCAPTCHA` react component
 * @usage `<react-invisible-recaptcha />`
 */
// eslint-disable-next-line camelcase
export const InvisibleReCAPTCHA_angularWrapper = makeAngularWrapper('Invisible', InvisibleReCAPTCHA);
/**
 * @description Angularjs wrapper for the `CompactReCAPTCHA` react component
 * @usage `<react-compact-recaptcha />`
 */
// eslint-disable-next-line camelcase
export const CompactReCAPTCHA_angularWrapper = makeAngularWrapper('Compact', CompactReCAPTCHA);
/**
 * @description Angularjs wrapper for the `CompactAudioReCAPTCHA` react component
 * @usage `<react-compact-audio-recaptcha />`
 */
// eslint-disable-next-line camelcase
export const CompactAudioReCAPTCHA_angularWrapper = makeAngularWrapper('CompactAudio', CompactAudioReCAPTCHA);
